/* eslint-disable camelcase */

import { useLocalization } from "@fluent/react";
import { modules } from "byzantine";
import Account from "byzantine/src/Account";
import Feature, { featureEquals } from "byzantine/src/Feature";
import { useUserFeatures } from "../../contexts/UserFeaturesContext";
import MemberFriendSection from "./MemberFriendSection";
import PayeeSection from "./PayeeSection";
import RecipientsSection from "./RecipientsSection";

export interface RecipientsProps {
  accounts: Account[];
}

const Recipients = ({ accounts }: RecipientsProps) => {
  const { l10n } = useLocalization();
  const userFeatures = useUserFeatures();
  const hasManageRecipientPermission =
    modules.achPayments.useManageRecipientPermission();
  const hasP2P = featureEquals(userFeatures, "p2p", "m2m");
  const hasWires = userFeatures.wires;
  const hasACH = userFeatures.ach_payments && hasManageRecipientPermission;

  let featuresListText: string = "";
  if (userFeatures.bill_pay && hasP2P && hasWires && hasACH) {
    featuresListText = l10n.getString("message-linked-recipients-bill-pay-p2p-wire-ach");
  } else if (userFeatures.bill_pay && hasP2P) {
    featuresListText = l10n.getString("message-linked-recipients-bill-pay-p2p");
  } else if (hasP2P && hasWires) {
    featuresListText = l10n.getString("message-linked-recipients-p2p-wire");
  } else if (userFeatures.bill_pay) {
    featuresListText = l10n.getString("message-linked-recipients-bill-pay");
  } else if (hasACH) {
    featuresListText = l10n.getString("message-linked-recipients-ach");
  }

  return (
    <div>
      <div className="margin--top--l">{featuresListText}</div>
      <Feature features={userFeatures} flag="bill_pay">
        <PayeeSection />
      </Feature>
      <Feature features={userFeatures} flag="p2p" equals="m2m">
        <MemberFriendSection accounts={accounts} />
      </Feature>
      {hasManageRecipientPermission ? (
        <Feature features={userFeatures} or={["ach_payments", "wires", "international_wires", "international_wires_consumer"]}>
          <RecipientsSection />
        </Feature>
      ) : null}
    </div>
  );
};

export default Recipients;
